import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, useSearchParams } from "react-router-dom";
import "./App.scss";
import { useAppDispatch, useAppSelector } from "@App/hooks/hooks";
import Loader from "@Components/loader/Loader";
import { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import Layout from "@Components/layout/Layout";
//import 'primereact/resources/themes/lara-light-indigo/theme.css';
import "primereact/resources/primereact.min.css";
import { RouteChangeSubscription } from "@Src/utils/subscriptions/route-change/route-change";
import {
	checkIsUserLoggedIn,
	getDataFromLocalStorageWithExpiry,
	getMachineId,
	getUserIpAddress,
	ipBasedUserLogin,
	removeDataFromLocalStorage,
	setDataOnLocalStorage,
} from "@Src/utils/globalUtilities";
import "bootstrap/dist/css/bootstrap.min.css";
import { LocalStorageDataModel } from "@Constants/local-storage-data-model";
import ReactGA from "react-ga";
import { getDataFromLocalStorage } from "@Src/utils/globalUtilities";
import { getUserInfo } from "./services/effects/otherEffects";
import { APIEnv, APIStatus } from "./services/learning/baseInterfaces";
import { setDataOnLocalStorageWithExpiry } from "@Src/utils/globalUtilities";
import { v4 as uuidv4 } from "uuid";
import { pushUtmSourceInformation } from "@Src/utils/globalUtilities";
import { LiveStream } from "@Components/live-stream/live-stream";
import {
	createEndmileAPITrackObject,
	postEndmileAPIEventTrack,
} from "./services/learning/eventTrack.service";
import {
	ENDMILE_API_EVENT_LIST,
	ENDMILE_API_FIELD_ID_MAPPING_LIST,
} from "@Constants/api-constants/endMileAPI.event.list";
import { useGet } from "./app/hooks/useGet/useGet";
import { USER_API_CONSTANTS } from "@Constants/api-constants/user/user.constant";
import { HOME_API_CONSTANTS } from "@Constants/api-constants/home/home.constant";
import { hideSpinner, showSpinner } from "./app/reducers/global/globalSlice";

const App: React.FC = () => {
	const dispatch = useAppDispatch();
	const location = useLocation();
	const params: any = new URLSearchParams(location.search);
	const { pathname, href } = window.location;
	const token = localStorage.getItem(LocalStorageDataModel.AUTH_TOKEN);
	const userIP = getDataFromLocalStorage(LocalStorageDataModel.USER_IP);
	const isSpinnerVisible = useAppSelector((state) => state.global);
	const [queryParams, setQueryParams] = useSearchParams()
	const endMileUserData = getDataFromLocalStorage(
		LocalStorageDataModel.ENDMILE_USER_DATA
	);

	const [machineId, setMachineId] = useState(
		getDataFromLocalStorage(LocalStorageDataModel.MACHINEID) ? true : false
	);
	const { data: userData } = useGet(
		USER_API_CONSTANTS.USER_PERSONAL_INFO,
		{},
		null,
		APIEnv.NODE_DASHBOARD,
		token
	);

	useEffect(() => {
		if (userData?.ResponseType == "SUCCESS") {
			const {
				firstName,
				lastName,
				designation,
				profession,
				state,
				mobile,
				countrycode,
				company,
				interestId,
				studentInterest,
			} = userData?.data;
			const endMileUserData = [];
			endMileUserData.push({
				fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.FIRST_NAME_LAST_NAME,
				value: firstName + " " + lastName || "",
			});
			endMileUserData.push({
				fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.COUNRTY_CODE,
				value: countrycode,
			});
			endMileUserData.push({
				fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.PHONE_NUMBER,
				value: mobile,
			});
			// endMileUserData.push({
			// 	fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.INSTITUTES,
			// 	value: company || "",
			// });
			endMileUserData.push({
				fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.STATE,
				value: state?.state_name || "",
			});
			endMileUserData.push({
				fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.DESGNATION,
				value: designation?.designationName || "",
			});

			if (interestId) {
				const interets = interestId?.map((el: any) => el?.name?.replace(/[^a-z0-9,-.()& ]/gi, ""))?.join("|")
				endMileUserData.push({
					fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.AREA_OF_SPECIALIZATION,
					value: interets,
				});
			} else if (studentInterest) {
				const interets =
					studentInterest?.course?.name?.replace(/[^a-z0-9,-.()& ]/gi, "") +
					"|" +
					studentInterest?.groupLevel?.name?.replace(/[^a-z0-9,-.()& ]/gi, "");

				endMileUserData.push({
					fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.AREA_OF_SPECIALIZATION,
					value: interets,
				});
			} else {
				endMileUserData.push({
					fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.AREA_OF_SPECIALIZATION,
					value: "",
				});
			}

			endMileUserData.push({
				fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.PROFESSION,
				value: profession?.profession_name || "",
			});

			setDataOnLocalStorage(
				LocalStorageDataModel.ENDMILE_USER_DATA,
				JSON.stringify(endMileUserData)
			);
		}
	}, [userData]);

	useEffect(() => {
		(async () => {
			await getMachineId().then(() => setMachineId(true));
			storeUtmInfo();
			if (!checkIsUserLoggedIn()) {
				dispatch(showSpinner())
				await getUserIpAddress().then((data) => {
					ipBasedUserLogin(data).then(res => {
						setDataOnLocalStorage(LocalStorageDataModel.EMAIL, res.user_email);
						setDataOnLocalStorage(LocalStorageDataModel.USER_NAME, res.user_name);
						setDataOnLocalStorage(LocalStorageDataModel.AUTH_TOKEN, res.login_token);
						setDataOnLocalStorage(LocalStorageDataModel.ISIPUSER, 'true');
						window.open("/learning/home", "_self")
						dispatch(hideSpinner())
					}).catch(() => {
						dispatch(hideSpinner())
					})
				})
					.catch(() => {
						dispatch(hideSpinner())
					})
			}
		})();
		return () => {
			removeDataFromLocalStorage(LocalStorageDataModel.ENDMILE_USER_DATA);
		};
	}, []);

	useEffect(() => {
		if (userIP) storeUtmInfo();
		(async () => {
			if (
				params.get("utm_medium") &&
				params.get("utm_medium")?.toLowerCase().includes("cid")
			) {
				let utm_medium_arr: any = params
					.get("utm_medium")
					?.toLowerCase()
					.split("cid");
				let cid = utm_medium_arr[1];
				setDataOnLocalStorageWithExpiry(
					LocalStorageDataModel.ENDMILE_EVENTS_CID_NUMBER,
					cid,
					24 * 60 * 60 * 100
				);
			}
		})();
	}, [params]);

	useEffect(() => {
		const activeCampaign: any = getDataFromLocalStorage(
			LocalStorageDataModel.UTM_CAMPAIGN_NAME
		);
		const utmData: any = getDataFromLocalStorage(activeCampaign);
		if (utmData?.["utm_campaign"] && userIP) {
			pushUtmSourceInformation("Page Viewed " + activeCampaign);
		}
	}, [location, userIP]);

	function storeUtmInfo() {
		if (params.get("utm_campaign")) {
			let utmInfo: any = {};
			params.forEach((value: any, key: any) => {
				if (key.includes("utm_")) {
					utmInfo[key] = value;
				}
			});
			setDataOnLocalStorage(
				params.get("utm_campaign"),
				JSON.stringify(utmInfo)
			);
			setDataOnLocalStorage("activeCampaign", params.get("utm_campaign"));
			setDataOnLocalStorage("activeCampaignUrl", pathname + location.search);
			pushUtmSourceInformation(
				"User Initial visit by " + params.get("utm_campaign")
			);
		}
		// else {
		// 	const activeCampaign: any = getDataFromLocalStorage(LocalStorageDataModel.UTM_CAMPAIGN_NAME);
		// 	localStorage.removeItem(LocalStorageDataModel.UTM_CAMPAIGN_NAME)
		// 	localStorage.removeItem(LocalStorageDataModel.UTM_CAMPAIGN_URL)
		// 	localStorage.removeItem(activeCampaign)
		// }
	}

	useEffect(() => {
		const currentPath = window.location.pathname;
		const previousUrl = localStorage.getItem(
			LocalStorageDataModel.PREVIOUS_URL
		);
		if (!previousUrl || previousUrl !== currentPath) {
			localStorage.setItem(LocalStorageDataModel.PREVIOUS_URL, currentPath);
		}
	}, [window.location.pathname]);

	useEffect(() => {
		(async () => {
			initializeGA4EventTrack();
			if (
				getDataFromLocalStorage(LocalStorageDataModel.AUTH_TOKEN) &&
				!getDataFromLocalStorage(LocalStorageDataModel.EXTRA_NETCORE_PAYLOAD)
			) {
				getUserInfo((response: any) => {
					if (response.ResponseType == APIStatus.SUCCESS) {
						const personalInfo = response.data;
						let netCorePayload: any = {
							name: personalInfo?.lastName
								? personalInfo?.firstName + " " + personalInfo?.lastName
								: personalInfo?.firstName || "",
							designation: personalInfo?.designation?.designationName || "",
							profession:
								personalInfo.profession?.profession_name ||
								personalInfo.professionNameOther ||
								(personalInfo?.studentInterest?.course?.id ? "students" : ""),
							email: personalInfo?.email || "",
							city: personalInfo?.city || "",
							state: personalInfo?.state?.state_name || "",
						};
						setDataOnLocalStorage(
							LocalStorageDataModel.EXTRA_NETCORE_PAYLOAD,
							JSON.stringify(netCorePayload)
						);
					}
				});
			}
		})();
	}, []);

	function initializeGA4EventTrack() {
		ReactGA.initialize("GTM-PF8RQLP");
	}

	const triggerPageVisitEndmileEvent = async () => {
		const fieldsData = [...JSON.parse(endMileUserData)];
		// fieldsData.push({
		// 	fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.PAGE_URL,
		// 	value: href,
		// });
		fieldsData.push({
			fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.WEBINAR_CATEGORY,
			value: "",
		});
		fieldsData.push({
			fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.PRODUCT_NAME,
			value: document.title,
		});
		let payload = await createEndmileAPITrackObject(
			ENDMILE_API_EVENT_LIST.PAGE_VISITED,
			fieldsData
		);
		postEndmileAPIEventTrack(payload);
	};

	/* Strip condition */
const [_, setRerender] = useState(0); // for triggering re-renders when body class changes

  // ✅ On Component Mount: Add class to <body>
  useEffect(() => {
    // document.body.classList.add('offer-strip-fixed');

    return () => {
      document.body.classList.remove('offer-strip-fixed');
    };
  }, []);

  // ✅ Remove class from <body>
  const toggleMenu = () => {
	let popUpScrolled = getDataFromLocalStorageWithExpiry(LocalStorageDataModel.PREMIUM_HEADER_STRIP);
	if (!popUpScrolled) {
		 setDataOnLocalStorageWithExpiry(LocalStorageDataModel.PREMIUM_HEADER_STRIP, true, 21600000);
	}
    document.body.classList.remove('offer-strip-fixed');
    setRerender(n => n + 1); // force re-render to reflect class change
  };

  // ✅ Check if class exists on <body>
  const hasMenuOpenClass = () => {
      let premiumStrip = getDataFromLocalStorageWithExpiry(LocalStorageDataModel.PREMIUM_HEADER_STRIP);
	  let currentUrl  = window.location.pathname
		if (!premiumStrip && !currentUrl.includes("checkout") && !currentUrl.includes("thank-you") && !currentUrl.includes("payment/invoice") && !window.location.href.includes('platform=premium')) {
			document.body.classList.add('offer-strip-fixed');
			return document.body.classList.contains('offer-strip-fixed');
		}else {
			document.body.classList.remove('offer-strip-fixed');
			return false;
		}
  };



	return (
		<div>

 {/* {hasMenuOpenClass() && (
        <div className="offer-strip-1">
          For professionals who demand precision and nothing less. Only at &nbsp; <a href='/premium'> Taxmann.com | Premium</a>

  <button className="freetrailclose" onClick={toggleMenu}>
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.3335 3.8335L12.6668 13.1668" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.33317 13.1668L12.6665 3.8335" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  </button>

        </div>
      )} */}

			{machineId ? <RouteChangeSubscription /> : null}
			{machineId ? <Routes>
				<Route path="/*" element={<Layout />} />
			</Routes> : null}
			{isSpinnerVisible.loading ? <Loader /> : null}
			<div>
				<div>
					<Toaster position="top-center" reverseOrder={false} />
				</div>
				{machineId && <LiveStream />}
			</div>
		</div>
	);
};

export default App;
